import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';

export const GET_NORTON_PRODUCTS_ATTRIBUTES = 'GET_NORTON_PRODUCTS_ATTRIBUTES';
export const GET_NORTON_PRODUCTS_ATTRIBUTES_SUCCESS =
  'GET_NORTON_PRODUCTS_ATTRIBUTES_SUCCESS';
export const GET_NORTON_PRODUCTS_ATTRIBUTES_FAILED =
  'GET_NORTON_PRODUCTS_ATTRIBUTES_FAILED';

export const GET_NORTON_PRODUCT_PRICE = 'GET_NORTON_PRODUCT_PRICE';
export const GET_NORTON_PRODUCT_PRICE_SUCCESS =
  'GET_NORTON_PRODUCT_PRICE_SUCCESS';
export const GET_NORTON_PRODUCT_PRICE_FAILED =
  'GET_NORTON_PRODUCT_PRICE_FAILED';

export const GET_NORTON_ACCOUNT = 'GET_NORTON_ACCOUNT';
export const GET_NORTON_ACCOUNT_SUCCESS = 'GET_NORTON_ACCOUNT_SUCCESS';
export const GET_NORTON_ACCOUNT_FAILED = 'GET_NORTON_ACCOUNT_FAILED';

export class GetNortonProductsAttributes implements Action {
  type = GET_NORTON_PRODUCTS_ATTRIBUTES;

  constructor(public payload?: any) {}
}

export class GetNortonProductsAttributesSuccess implements Action {
  type = GET_NORTON_PRODUCTS_ATTRIBUTES_SUCCESS;

  constructor(public payload: any) {}
}

export class GetNortonProductsAttributesFailed implements Action {
  type = GET_NORTON_PRODUCTS_ATTRIBUTES_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetNortonProductPrice implements Action {
  type = GET_NORTON_PRODUCT_PRICE;

  constructor(public payload?: any) {}
}

export class GetNortonProductPriceSuccess implements Action {
  type = GET_NORTON_PRODUCT_PRICE_SUCCESS;

  constructor(public payload: any) {}
}

export class GetNortonProductPriceFailed implements Action {
  type = GET_NORTON_PRODUCT_PRICE_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetNortonAccount implements Action {
  type = GET_NORTON_ACCOUNT;

  constructor(public payload?: any) {}
}

export class GetNortonAccountSuccess implements Action {
  type = GET_NORTON_ACCOUNT_SUCCESS;

  constructor(public payload: any) {}
}

export class GetNortonAccountFailed implements Action {
  type = GET_NORTON_ACCOUNT_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions =
  | GetNortonProductsAttributes
  | GetNortonProductsAttributesSuccess
  | GetNortonProductsAttributesFailed
  | GetNortonProductPrice
  | GetNortonProductPriceSuccess
  | GetNortonProductPriceFailed
  | GetNortonAccount
  | GetNortonAccountSuccess
  | GetNortonAccountFailed;
